import React from "react";
import Button from "@amzn/meridian/esm/components/button";
import Column from "@amzn/meridian/esm/components/column";
import Modal from "@amzn/meridian/esm/components/modal";
import Row from "@amzn/meridian/esm/components/row";
import Text from "@amzn/meridian/esm/components/text";
import Theme from "@amzn/meridian/esm/components/theme/theme";
import errorIcon from "../../images/error_icon.svg";

import aimsTheme from "../../meridian-theme-aims.json";
import { SESSION_STATUS_MESSAGE } from "../utils/RtmsSessionStatusUtils";

const RtmsErrorModal = ({ isOpen, onCancel, onRestart, errorType }) => {
  const getErrorContent = () => {
    if (errorType === SESSION_STATUS_MESSAGE.RTMS_INIT_ERROR) {
      return {
        title: "Server not responding",
        description: `Click "Restart" to summarize this meeting.`
      };
    } else if (errorType === SESSION_STATUS_MESSAGE.RTMS_RUNTIME_ERROR) {
      return {
        title: "Meeting summary stopped unexpectedly.",
        description: `Click "Restart" to summarize this meeting.`,
        description2: `You'll receive a separate meeting summary.`
      };
    }
  };

  const errorContent = getErrorContent();

  return (
    <Theme
      palette={aimsTheme}
      tokens={{
        modalHeaderBackgroundColor: "rgba(124, 209, 187, 0.6)",
        modalHeaderSpacingInsetTop: "0px",
        modalHeaderSpacingInsetBottom: "0px",
        modalHeaderFontSize: "8px",
        modalHeaderMinHeight: "8px",
        modalFooterBorderColor: "#FFFFFF",
      }}
    >
      <Modal
        open={isOpen}
        closeLabel={null}
        shouldCloseOnOverlayClick={true}
        aria-describedby="modal-description"
        fullscreenBreakpoint="0"
        title=" "
        bodySpacingInset="400"
        width="292px"
      >
        <Column spacing="none" spacingInset="none">
          <Column height="16px" />
          <Column spacing="none" spacingInset="none">
            <Row alignmentHorizontal="center" widths="40" spacing="none" spacingInset="none">
              <img src={errorIcon} alt="errorIcon" style={{ display: "block", margin: "auto", width: "40px", height: "auto" }} />
            </Row>
          </Column>
          <Column height="16px" />
          {/* title: Server not responding
          description: Click "Restart" to summarize this meeting.
          description2: You'll receive a separate meeting summary. */}
          <Row spacing="none" spacingInset="none">
            <Column width="28px"/>
            <Column spacing="none" spacingInset="none">
              <Column spacing="none" spacingInset="none">
                <Row spacing="none" spacingInset="none">
                  <Column>
                    <Text fontFamily="amazonEmber" type="h100" alignment="start">
                      {errorContent.title}
                    </Text>
                  </Column>
                </Row>
              </Column>
              <Column height="8px" />
              <Column spacing="none" spacingInset="none">
                <Row spacing="none" spacingInset="none">
                  <Column>
                    <Text fontFamily="amazonEmber" type="b200" alignment="start">
                      {errorContent.description}
                    </Text>
                  </Column>
                </Row>
              </Column>
              {errorContent.description2 &&
                <>
                    <Column height="8px" />
                    <Column spacing="none" spacingInset="none">
                      <Text fontFamily="amazonEmber" type="b200" alignment="start">
                        {errorContent.description2}
                      </Text>
                    </Column>
                </>
              }
            </Column>
          </Row>
          <Column height="16px" />
          <Column height="32px">
            <Row alignmentHorizontal="center" spacing="none" spacingInset="none">
                <Column width="34px"/>
                  <Button type="icon" size="small" minWidth="88px" onClick={onCancel}>
                      <Theme tokens={{
                          textColorPrimary: "#006D5B"
                      }}>
                        <Text>Cancel</Text>
                      </Theme>
                  </Button>      
                <Button type="primary" size="small" minWidth="88px" onClick={onRestart}>
                    Restart
                </Button>
              </Row>
          </Column>
          <Column height="32px"/>
        </Column>
      </Modal>
    </Theme>
  );
};

export default RtmsErrorModal;
